import "core-js/modules/web.dom-collections.iterator.js";
import React, { useMemo, useState, useCallback } from "react";
import Box from "../Box";
import { createEmptyAppliedFilter } from ".";
import FormGroup from "../FormGroup";
import FormControlLabel from "../FormControlLabel";
import Checkbox from "../Checkbox";
import FormControl from "../FormControl";
import { ClearButton } from "../ListAppliedFilterChip";
const ListFilterMultiCheckbox = _ref => {
  let {
    searchFilter,
    appliedSearchFilter,
    onChangeAppliedFilter
  } = _ref;
  const [expanded, setExpanded] = useState(false);
  const appliedFilterValues = useMemo(() => {
    return (appliedSearchFilter === null || appliedSearchFilter === void 0 ? void 0 : appliedSearchFilter.filterValues.length) > 0 ? appliedSearchFilter.filterValues : [];
  }, [appliedSearchFilter === null || appliedSearchFilter === void 0 ? void 0 : appliedSearchFilter.filterValues //needed to shallow compare changes 
  ]);
  const appliedFilterListValuesOptions = useMemo(() => {
    if (appliedFilterValues.length > 0) {
      return appliedFilterValues.map(value => ({
        value: value.value,
        label: value.label
      }));
    } else {
      return [];
    }
  }, [appliedFilterValues]);
  const handleChangeValue = useCallback((e, valueOptions) => {
    if (valueOptions != null && valueOptions.length > 0) {
      const filterValues = valueOptions.map(valueOption => {
        return {
          value: valueOption.value,
          label: valueOption.label,
          context: null
        };
      });
      const newAppliedSearchFilter = appliedSearchFilter ? appliedSearchFilter : createEmptyAppliedFilter(searchFilter);
      newAppliedSearchFilter.filterValues = filterValues;
      const plusLabel = filterValues.length > 1 ? " + ".concat(filterValues.length - 1) : "";
      newAppliedSearchFilter.displayLabel = "".concat(searchFilter.label, ": ").concat(filterValues[0].label).concat(plusLabel);
      onChangeAppliedFilter(searchFilter, newAppliedSearchFilter);
    } else {
      onChangeAppliedFilter(searchFilter, null);
    }
  }, [searchFilter, appliedSearchFilter === null || appliedSearchFilter === void 0 ? void 0 : appliedSearchFilter.filterValues,
  //needed to shallow compare changes 
  onChangeAppliedFilter, createEmptyAppliedFilter]);
  const handleCheckChange = (e, option) => {
    let newOptions = [...appliedFilterListValuesOptions];
    if (e.target.checked) {
      newOptions.push(option);
    } else {
      newOptions = newOptions.filter(appliedValue => appliedValue.value !== option.value);
    }
    handleChangeValue(e, newOptions);
  };
  const handleExpandContract = e => {
    e.preventDefault();
    setExpanded(!expanded);
  };
  const limit = (searchFilter === null || searchFilter === void 0 ? void 0 : searchFilter.showMoreLimit) || 10;
  const labelShowMore = (searchFilter === null || searchFilter === void 0 ? void 0 : searchFilter.labelShowMore) || "Show More";
  const labelShowLess = (searchFilter === null || searchFilter === void 0 ? void 0 : searchFilter.labelShowLess) || "Show Less";
  const overrideExpanded = !!appliedFilterListValuesOptions.find(appliedValue => searchFilter.options.findIndex(option => option.value === appliedValue.value) > limit - 1);
  const visibleOptions = overrideExpanded ? searchFilter.options : searchFilter.options.length > limit && !expanded ? searchFilter.options.slice(0, limit) : searchFilter.options;
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: "flex",
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(FormGroup, null, visibleOptions.map(option => {
    const checked = !!appliedFilterListValuesOptions.find(appliedValue => appliedValue.value === option.value);
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      key: option.value,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        onChange: e => handleCheckChange(e, option),
        checked: checked
      }),
      label: option.label
    });
  })), !overrideExpanded && searchFilter.options.length > limit && /*#__PURE__*/React.createElement(ClearButton, {
    onClick: handleExpandContract
  }, expanded || overrideExpanded ? labelShowLess : labelShowMore)));
};
export default ListFilterMultiCheckbox;